/* eslint-disable react/jsx-key */
import React, { useState, useEffect, useCallback } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import Lottie from 'react-lottie';
import Switch, { switchClasses } from '@mui/joy/Switch';

import { ContainerStudies, ContainerLoading } from './style.js';
import Loading from '../../../assets/loading.json';
import Menu from '../../../components/Menu/index.js';
import Footer from '../../../components/Footer/index.js';
import AuthGuard from '../../../components/AuthGuard/index.js';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';

import api from '../../../services/api.js';

import ButtonDefault from '../../../components/ButtonDefault/index.js';
import SelectDefault from '../../../components/SelectDefault/index.js';
import InputDefault from '../../../components/InputDefault/index.js';
import ButtonAction from '../../../components/ButtonAction/index.js';
import ModalDelete from '../../../components/Modals/ModalDelete/index.js';
import ModalAdd from '../../../components/Modals/ModalAdd/index.js';
import ModalEdit from '../../../components/Modals/ModalEdit/index.js';

const UserList = () => {
  document.title = 'Enermerco - Usuários';

  const [isLoading, setIsLoading] = useState(true);

  const [userList, setUserList] = useState([]);

  const [id, setId] = useState('');
  const [type, setType] = useState('0');
  const [situation, setSituation] = useState('A');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [nrFone, setNrFone] = useState('');
  const [nrCpfCnpj, setNrCpfCnpj] = useState('');
  const [currentEmail, setCurrentEmail] = useState('');
  const [currentSituation, setCurrentSituation] = useState('');
  const [idDm017, setIdDm017] = useState('');
  const [salesChannelList, setSalesChannelList] = useState([]);

  const [modalStatus, setModalStatus] = useState('');
  const [modalName, setModalName] = useState('');
  const [modalTextPassword, setModalTextPassword] = useState('');
  const [modalNrFone, setModalNrFone] = useState('');
  const [modalNrCpfCnpj, setModalNrCpfCnpj] = useState('');
  const [modalIdDm017, setModalIdDm017] = useState('');

  const [modalAdd, setModalAdd] = useState(false);
  const [modalEdit, setModalEdit] = useState(false);
  const [modalUserDesc, setModalUserDesc] = useState('');

  const [modalDelete, setModalDelete] = useState(false);

  const loadingAnimation = {
    loop: true,
    autoplay: true,
    animationData: Loading
  };

  // Mask functions
  const maskPhone = (value) => {
    if (!value) return '';
    const cleaned = value.replace(/\D/g, '');
    
    if (cleaned.length <= 10) {
      // (XX) XXXX-XXXX
      return cleaned.replace(/(\d{2})(\d{4})(\d{0,4})/, '($1) $2-$3').replace(/-$/, '');
    } else {
      // (XX) XXXXX-XXXX
      return cleaned.replace(/(\d{2})(\d{5})(\d{0,4})/, '($1) $2-$3').replace(/-$/, '');
    }
  };

  const maskCpfCnpj = (value) => {
    if (!value) return '';
    const cleaned = value.replace(/\D/g, '');
    
    if (cleaned.length <= 11) {
      // CPF: XXX.XXX.XXX-XX
      return cleaned.replace(/(\d{3})(\d{3})(\d{3})(\d{0,2})/, '$1.$2.$3-$4').replace(/-$/, '');
    } else {
      // CNPJ: XX.XXX.XXX/XXXX-XX
      return cleaned.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{0,2})/, '$1.$2.$3/$4-$5').replace(/-$/, '');
    }
  };

  const loadSalesChannels = () => {
    api
      .get('sales_channel?situation=A')
      .then((response) => {
        setSalesChannelList(response.data.data);
      })
      .catch((err) => {
        console.log('Erro ao carregar canais de venda:', err);
      });
  };

  const applyFilter = (id, type, situation, name, email, nrFone, nrCpfCnpj) => {
    console.log(type, situation);
    let url = 'users?';
    if (situation !== 'T' && situation !== '') {
      url += `situation=${situation}`;
    }
    if (type !== '0' && type !== '') {
      url += `&type=${type}`;
    }
    if (id !== '') {
      url += `&id=${id}`;
    }
    if (name !== '') {
      url += `&name=${name}`;
    }
    if (email !== '') {
      url += `&email=${email}`;
    }
    if (nrFone !== '') {
      url += `&nr_fone=${nrFone}`;
    }
    if (nrCpfCnpj !== '') {
      url += `&nr_cpfcnpj=${nrCpfCnpj}`;
    }
    if (idDm017 !== '') {
      url += `&id_dm017=${idDm017}`;
    }
    api
      .get(url)
      .then((response) => {
        setUserList(response.data.data);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const searchFilter = useCallback(() => {
    applyFilter(id, type, situation, name, email, nrFone, nrCpfCnpj);
  }, [id, type, situation, name, email, nrFone, nrCpfCnpj]);

  const cleanFields = useCallback(() => {
    setId('');
    setType('0');
    setSituation('A');
    setName('');
    setEmail('');
    setNrFone('');
    setNrCpfCnpj('');
    setIdDm017('');
    applyFilter('', '0', 'A', '', '', '', '');
  }, [id, type, situation, name, email, nrFone, nrCpfCnpj, idDm017]);

  const deleteUser = useCallback(
    (id) => {
      api
        .delete(`user?id=${id}`)
        .then((response) => {
          setModalDelete(false);
          if (response.status === 200) {
            toast.success('Usuário removido com sucesso!');
          } else {
            toast.error(response.data.message);
          }
          cleanFields();
        })
        .catch((error) => {
          cleanFields();
          setModalDelete(false);
          toast.success(error);
        });
    },
    [modalDelete]
  );

  const addUser = useCallback(
    (
      modalText,
      _modalNumber1,
      _modalNumber2,
      _modalNumber3,
      _id,
      _date,
      modalText2,
      type,
      modalTextPassword,
      modalNrFone,
      modalNrCpfCnpj,
      modalIdDm017Param
    ) => {
      const data = {
        email: modalText2,
        password: modalTextPassword,
        name: modalText.toUpperCase(),
        type: type,
        nr_fone: modalNrFone?.replace(/\D/g, ''),
        nr_cpfcnpj: modalNrCpfCnpj?.replace(/\D/g, ''),
        sales_channel_id: modalIdDm017Param
      };
      if (modalTextPassword.length < 6) {
        setModalAdd(false);
        cleanFields();
        toast.error('Verifique a senha, ela deve ter no mínimo 6 caracteres!');
        return;
      }
      if (!modalIdDm017Param) {
        setModalAdd(false);
        cleanFields();
        toast.error('É obrigatório selecionar um Canal de Venda!');
        return;
      }
      console.log('data');
      console.log(data);
      api
        .post(`create_user`, data)
        .then((response) => {
          setModalAdd(false);
          if (response.status === 201) {
            toast.success('Usuário adicionado com sucesso!');
          } else {
            toast.error(response.data.message);
          }
          cleanFields();
        })
        .catch((error) => {
          setModalAdd(false);
          cleanFields();
          toast.error('Erro ao adicionar usuário: ' + error.response.data.message);
        });
    },
    [modalAdd]
  );

  const editUser = useCallback(
    (
      modalText,
      _modalNumber1,
      _modalNumber2,
      _modalNumber3,
      id,
      modalStatus,
      _date,
      modalTextPassword,
      modalNrFone,
      modalNrCpfCnpj,
      modalIdDm017Param
    ) => {
      if (!modalIdDm017Param) {
        setModalEdit(false);
        cleanFields();
        toast.error('É obrigatório selecionar um Canal de Venda!');
        return;
      }
      console.log(modalText, id, modalStatus, modalTextPassword);
      let data = {};
      if (modalTextPassword === '') {
        data = {
          email: currentEmail,
          situation: currentSituation,
          name: modalText.toUpperCase(),
          type: modalStatus,
          nr_fone: modalNrFone?.replace(/\D/g, ''),
          nr_cpfcnpj: modalNrCpfCnpj?.replace(/\D/g, ''),
          sales_channel_id: modalIdDm017Param
        };
      } else {
        data = {
          email: currentEmail,
          situation: currentSituation,
          name: modalText.toUpperCase(),
          type: modalStatus,
          password: modalTextPassword,
          nr_fone: modalNrFone?.replace(/\D/g, ''),
          nr_cpfcnpj: modalNrCpfCnpj?.replace(/\D/g, ''),
          sales_channel_id: modalIdDm017Param
        };
      }
      api
        .put(`update_user?id=${id}`, data)
        .then((response) => {
          console.log(response);
          setModalEdit(false);
          if (response.status === 201) {
            toast.success('Usuário alterado com sucesso!');
          } else {
            toast.error(response.data.message);
          }
          setCurrentEmail('');
          setCurrentSituation('');
          cleanFields();
        })
        .catch((error) => {
          setCurrentEmail('');
          setCurrentSituation('');
          cleanFields();
          setModalEdit(false);
          if (error.status === 422) {
            toast.error('Verifique a senha, ela deve ter no mínimo 6 caracteres!');
          }
        });
    },
    [modalEdit]
  );

  useEffect(() => {
    applyFilter(id, type, situation, name, email, nrFone, nrCpfCnpj);
    loadSalesChannels();
  }, [type, situation]);

  const statusDescription = (status) => {
    switch (status) {
      case 'A':
        return 'ATIVO';
      case 'I':
        return 'INATIVO';
      default:
        return 'NÃO DEFINIDO';
    }
  };

  const typeDescription = (status) => {
    switch (status) {
      case '1':
        return 'ADMINISTRADOR';
      case '2':
        return 'USUÁRIO';
      case '3':
        return 'VENDEDOR';
      default:
        return 'NÃO DEFINIDO';
    }
  };

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const updateUserStatus = (status, user) => {
    console.log(user);
    console.log(status);
    api
      .put(`update_user?id=${user.id}`, {
        email: user.email,
        name: user.name,
        type: user.IN_TIPO,
        situation: status ? 'A' : 'I',
        nr_fone: user.NR_FONE,
        nr_cpfcnpj: user.NR_CPFCNPJ,
        sales_channel_id: user.ID_DM017
      })
      .then((response) => {
        setModalEdit(false);
        if (response.status === 201) {
          toast.success('Usuário alterado com sucesso!');
        } else {
          toast.error(response.data.message);
        }
        cleanFields();
      })
      .catch((error) => {
        setModalEdit(false);
        toast.success(error);
      });
  };

  return (
    <>
      <AuthGuard />
      <Menu />
      {isLoading ? (
        <ContainerLoading>
          <Lottie options={loadingAnimation} style={{ width: '100%', height: 400 }} />
          <h1>Carregando Usuários...</h1>
        </ContainerLoading>
      ) : (
        <Container>
          <ContainerStudies>
            <h2>Lista de Usuários</h2>
            <ButtonDefault
              Width={'150px'}
              Margin={'0px 30px 30px 0px'}
              Text="Adicionar"
              onClick={() => {
                setModalAdd(true);
              }}
            />
            <h3>Filtros</h3>
            <Row>
              <Col xs={3}>
                <SelectDefault
                  Width={'100%'}
                  Margin={'10px 0px 15px 0px'}
                  Text={'Situação'}
                  value={`${situation}`}
                  onChange={(e) => {
                    setSituation(e.target.value);
                  }}>
                  <option value="A">ATIVO</option>
                  <option value="I">INATIVO</option>
                  <option value="T">TODOS</option>
                </SelectDefault>
              </Col>
              <Col xs={3}>
                <SelectDefault
                  Width={'100%'}
                  Margin={'10px 0px 15px 0px'}
                  Text={'Tipo de Usuário'}
                  value={`${type}`}
                  onChange={(e) => {
                    setType(e.target.value);
                  }}>
                  <option value="1">ADMINISTRADOR</option>
                  <option value="2">USUÁRIO</option>
                  <option value="0">TODOS</option>
                </SelectDefault>
              </Col>
              <Col xs={2}>
                <InputDefault
                  placeholder="Código do Usuário"
                  Width={'100%'}
                  Margin={'10px 0px 15px 0px'}
                  Text={'Código'}
                  value={`${id}`}
                  onChange={(e) => setId(e.target.value)}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={3}>
                <InputDefault
                  placeholder="Nome da Usuário"
                  Width={'100%'}
                  Margin={'10px 0px 15px 0px'}
                  Text={'Nome'}
                  value={`${name}`}
                  onChange={(e) => setName(e.target.value)}
                />
              </Col>
              <Col xs={3}>
                <InputDefault
                  placeholder="E-mail da Usuário"
                  Width={'100%'}
                  Margin={'10px 0px 15px 0px'}
                  Text={'E-mail'}
                  value={`${email}`}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </Col>
              <Col xs={3}>
                <InputDefault
                  placeholder="Telefone do Usuário"
                  Width={'100%'}
                  Margin={'10px 0px 15px 0px'}
                  Text={'Telefone'}
                  value={maskPhone(nrFone)}
                  onChange={(e) => setNrFone(e.target.value.replace(/\D/g, ''))}
                />
              </Col>
              <Col xs={3}>
                <InputDefault
                  placeholder="CPF/CNPJ do Usuário"
                  Width={'100%'}
                  Margin={'10px 0px 15px 0px'}
                  Text={'CPF/CNPJ'}
                  value={maskCpfCnpj(nrCpfCnpj)}
                  onChange={(e) => setNrCpfCnpj(e.target.value.replace(/\D/g, ''))}
                />
              </Col>
              <Col xs={3}>
                <SelectDefault
                  Width={'100%'}
                  Margin={'10px 0px 15px 0px'}
                  Text={'Canal de Venda'}
                  value={`${idDm017}`}
                  onChange={(e) => {
                    setIdDm017(e.target.value);
                  }}>
                  <option value="">TODOS</option>
                  {salesChannelList.map((channel) => (
                    <option key={channel.ID_DM017} value={channel.ID_DM017}>
                      {channel.NM_CANAL}
                    </option>
                  ))}
                </SelectDefault>
              </Col>
            </Row>
            <ButtonDefault
              Width={'150px'}
              Margin={'20px 30px 30px 0px'}
              Text="Buscar"
              onClick={searchFilter}
            />
            <ButtonDefault
              Width={'150px'}
              Margin={'20px 30px 30px 0px'}
              Text="Limpar"
              onClick={() => {
                cleanFields();
              }}
            />
            <Table striped bordered hover variant="light">
              <thead>
                <tr>
                  <th style={{ width: '5%', textAlign: 'right' }}>Código</th>
                  <th style={{ width: '15%' }}>Nome</th>
                  <th style={{ width: '15%' }}>E-mail</th>
                  <th style={{ width: '10%' }}>Telefone</th>
                  <th style={{ width: '10%' }}>CPF/CNPJ</th>
                  <th style={{ width: '15%' }}>Canal de Venda</th>
                  <th style={{ width: '5%' }}>Tipo</th>
                  <th style={{ width: '5%' }}>Situação</th>
                  <th style={{ width: '5%' }}>Alteração</th>
                  <th style={{ width: '10%', textAlign: 'center' }}>Ação</th>
                </tr>
              </thead>
              <tbody>
                {userList.map((user) => (
                  <tr key={user.id}>
                    <td style={{ textAlign: 'right' }}>{user.id}</td>
                    <td>{user.name}</td>
                    <td>{user.email}</td>
                    <td>{maskPhone(user.NR_FONE)}</td>
                    <td>{maskCpfCnpj(user.NR_CPFCNPJ)}</td>
                    <td>{user.NM_CANAL || 'Não informado'}</td>
                    <td>{typeDescription(user.IN_TIPO)}</td>
                    <td style={{ textAlign: 'center' }}>
                      {
                        <Switch
                          color={user.IN_SITUACAO === 'A' ? 'success' : 'danger'}
                          checked={user.IN_SITUACAO === 'A'}
                          onChange={(event) => updateUserStatus(event.target.checked, user)}
                          sx={{
                            '--Switch-thumbSize': '16px',
                            '--Switch-trackWidth': '40px',
                            '--Switch-trackHeight': '24px',
                            '--Switch-trackBackground': '#EE5E52',
                            '&:hover': {
                              '--Switch-trackBackground': '#EE5E52'
                            },
                            [`&.${switchClasses.checked}`]: {
                              '--Switch-trackBackground': '#5CB176',
                              '&:hover': {
                                '--Switch-trackBackground': '#5CB176'
                              }
                            }
                          }}
                        />
                      }
                    </td>

                    <td>{formatDate(user.updated_at)}</td>
                    <td
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        height: '45px',
                        justifyContent: 'center'
                      }}>
                      <ButtonAction
                        Action="Edit"
                        onClick={() => {
                          setId(user.id);
                          setModalTextPassword('');
                          setModalName(user.name);
                          setCurrentSituation(user.IN_SITUACAO);
                          setCurrentEmail(user.email);
                          setModalStatus(user.IN_TIPO);
                          setModalNrFone(user.NR_FONE || '');
                          setModalNrCpfCnpj(user.NR_CPFCNPJ || '');
                          setModalIdDm017(user.ID_DM017 || '');
                          setModalEdit(true);
                        }}
                      />
                      <ButtonAction
                        Action="Remove"
                        onClick={() => {
                          setId(user.id);
                          setModalUserDesc(user.name);
                          setModalDelete(true);
                        }}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </ContainerStudies>
          <ToastContainer />
          <ModalDelete
            modalOpen={modalDelete}
            handleClose={() => setModalDelete(false)}
            handleConfirm={deleteUser}
            handleCancel={() => setModalDelete(false)}
            modalTitleText={`Deseja excluir a Distribuidora #${id}?`}
            modalText={modalUserDesc}
            id={id}
          />
          <ModalAdd
            modalOpen={modalAdd}
            handleClose={() => setModalAdd(false)}
            handleConfirm={(modalText, modalNumber1, modalNumber2, modalNumber3, id, date, modalText2, type, modalTextPassword) => 
              addUser(modalText, modalNumber1, modalNumber2, modalNumber3, id, date, modalText2, type, modalTextPassword, modalNrFone, modalNrCpfCnpj, modalIdDm017)
            }
            handleCancel={() => setModalAdd(false)}
            modalTitleText={'Adicionar Usuário'}
            visibleText={true}
            visibleText2={true}
            visibleTextPassword={true}
            placeHolderText={'Nome'}
            textLabel={'Nome do Usuário'}
            placeHolderText2={'E-mail'}
            textLabel2={'E-mail do Usuário'}
            visibleType={true}
            visibleNrFone={true}
            modalNrFone={modalNrFone}
            setModalNrFone={setModalNrFone}
            maskPhone={maskPhone}
            visibleNrCpfCnpj={true}
            modalNrCpfCnpj={modalNrCpfCnpj}
            setModalNrCpfCnpj={setModalNrCpfCnpj}
            maskCpfCnpj={maskCpfCnpj}
            visibleSalesChannel={true}
            modalSalesChannel={modalIdDm017}
            setModalSalesChannel={setModalIdDm017}
            salesChannelList={salesChannelList}
            salesChannelLabel="Canal de Venda (Obrigatório)"
          />
          <ModalEdit
            modalOpen={modalEdit}
            handleClose={() => setModalEdit(false)}
            handleConfirm={(modalText, modalNumber1, modalNumber2, modalNumber3, id, modalStatus, date, modalTextPassword) =>
              editUser(modalText, modalNumber1, modalNumber2, modalNumber3, id, modalStatus, date, modalTextPassword, modalNrFone, modalNrCpfCnpj, modalIdDm017)
            }
            handleCancel={() => setModalEdit(false)}
            modalTitleText={`Editar Usuário #${id}`}
            visibleText={true}
            visibleTextPassword={true}
            textLabel={'Nome do Usuário'}
            id={id}
            setModalText={setModalName}
            modalText={modalName}
            modalTextPassword={modalTextPassword}
            setModalTextPassword={setModalTextPassword}
            modalNumber1={''}
            setModalNumber1={() => {}}
            modalNumber2={''}
            setModalNumber2={() => {}}
            modalNumber3={''}
            setModalNumber3={() => {}}
            visibleStatus={true}
            modalStatus={modalStatus}
            setModalStatus={setModalStatus}
            selectType={1}
            visibleNrFone={true}
            modalNrFone={modalNrFone}
            setModalNrFone={setModalNrFone}
            maskPhone={maskPhone}
            visibleNrCpfCnpj={true}
            modalNrCpfCnpj={modalNrCpfCnpj}
            setModalNrCpfCnpj={setModalNrCpfCnpj}
            maskCpfCnpj={maskCpfCnpj}
            visibleSalesChannel={true}
            modalSalesChannel={modalIdDm017}
            setModalSalesChannel={setModalIdDm017}
            salesChannelList={salesChannelList}
            salesChannelLabel="Canal de Venda (Obrigatório)"
          />
          <Footer />
        </Container>
      )}
    </>
  );
};

export default UserList;
